"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBlockOffset_1 = __importDefault(require("../query/getBlockOffset"));
const getFragmentNode = (el) => {
    if (el == null) {
        return null;
    }
    if (el.dataset && el.dataset.blockKey != null && el.dataset.fragmentStart != null) {
        const _el = el;
        return _el;
    }
    else if (el.parentElement) {
        return getFragmentNode(el.parentElement);
    }
    return null;
};
function getFragmentOffset(list, node) {
    const fragment = getFragmentNode(node);
    if (fragment == null)
        return null;
    const { fragmentStart, blockKey } = fragment.dataset;
    const blockOffset = getBlockOffset_1.default(list, blockKey);
    if (blockOffset == null)
        return null;
    return blockOffset + parseInt(fragmentStart);
}
exports.default = getFragmentOffset;
//# sourceMappingURL=getFragmentOffset.js.map